import { FileTextOutlined } from "@ant-design/icons"
import { Flex, Input } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type Lead } from "../../types/lead.types.ts"
import { WorkspaceCard } from "../cards/WorkspaceCard.tsx"
import { type LeadPatchSender } from "../lead-workspace-patch.ts"
import { LeadOverviewField } from "../overview/LeadOverviewField.tsx"
import { OverviewCardTitle } from "../overview/OverviewCardIcon.tsx"

interface ScopeDescriptionValues {
  scope: string | null
  comments: string | null
}

interface LeadScopeDescriptionCardProps {
  lead: Lead
  canEdit?: boolean
  onPatch: LeadPatchSender
}

function LeadScopeDescriptionCard({
  lead,
  canEdit,
  onPatch
}: LeadScopeDescriptionCardProps) {
  const { t } = useTranslation()

  const values: ScopeDescriptionValues = {
    scope: lead?.scope ?? null,
    comments: lead?.comments ?? null
  }

  return (
    <WorkspaceCard<ScopeDescriptionValues>
      cardId={"scope-description"}
      title={
        <OverviewCardTitle icon={<FileTextOutlined />} accent={"indigo"}>
          {t("leadWorkspace.scope.description.title")}
        </OverviewCardTitle>
      }
      ariaTitle={t("leadWorkspace.scope.description.title")}
      className={"h-full"}
      canEdit={canEdit}
      values={values}
      onSave={onPatch}
      renderEdit={({ values, setValues, saving }) => (
        <Flex vertical gap={"small"}>
          <LeadOverviewField label={t("leadWorkspace.cards.project.scope")}>
            <Input.TextArea
              autoFocus
              rows={4}
              disabled={saving}
              aria-label={t("leadWorkspace.cards.project.scope")}
              value={values.scope ?? ""}
              onChange={(event) =>
                setValues({ scope: event.target.value || null })
              }
            />
          </LeadOverviewField>
          <LeadOverviewField
            label={t("leadWorkspace.cards.project.description")}
          >
            <Input.TextArea
              rows={4}
              disabled={saving}
              aria-label={t("leadWorkspace.cards.project.description")}
              value={values.comments ?? ""}
              onChange={(event) =>
                setValues({ comments: event.target.value || null })
              }
            />
          </LeadOverviewField>
        </Flex>
      )}
    >
      <Flex vertical gap={"small"}>
        <LeadOverviewField
          label={t("leadWorkspace.cards.project.scope")}
          value={lead?.scope}
        />
        <LeadOverviewField
          label={t("leadWorkspace.cards.project.description")}
          value={lead?.comments}
        />
      </Flex>
    </WorkspaceCard>
  )
}

export { type ScopeDescriptionValues, LeadScopeDescriptionCard }
